export default __webpack_public_path__ + "slices/main/assets/public/podcast-subscribe-toggle/spotify.ffa77d3ad571a47ecc4c62cf2c5e5942.svg";